import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User exported media from a canvas',
  name: 'canvas_media_exported',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The number of media items exported',
      name: 'number_of_media',
      required: true,
      type: 'number',
    },
    {
      description: 'Where the media was exported to',
      name: 'destination',
      required: true,
      type: 'enum',
      values: ['desktop', 'workspace'],
    },
    {
      description: 'The id of the board the media was exported to',
      name: 'board_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
